import CommonUtils from '@/resources/utils/common-utils';
import API from '@/config/api';


const article = {

    state: {

    },

    mutations: {

        getArticleCategoryLists(state, data) {
            data.url = API.article.getArticleCategoryLists;
            CommonUtils.GetRequest(data);
        },

        getArticleCategoryListsNoPagination(state, data) {
            data.url = API.article.getVideoCategoryListsNoPagination;
            CommonUtils.GetRequest(data);
        },

        toggleArticleCategoryStatus(state, data) {
            data.url = API.article.toggleArticleCategoryStatus;
            CommonUtils.PostRequest(data);
        },

        deleteArticleCategory(state, data) {
            data.url = API.article.deleteArticleCategory;
            CommonUtils.GetRequest(data);
        },

        addArticleCategory(state, data) {
            data.url = API.article.addArticleCategory;
            CommonUtils.PostRequest(data);
        },

        getArticleCategoryInfo(state, data) {
            data.url = API.article.getArticleCategoryInfo;
            CommonUtils.GetRequest(data);
        },

        editArticleCategory(state, data) {
            data.url = API.article.editArticleCategory;
            CommonUtils.PostRequest(data);
        },

        getArticleTagsLists(state, data) {
            data.url = API.article.getArticleTagsLists;
            CommonUtils.GetRequest(data);
        },

        getArticleTagListsNoPagination(state, data) {
            data.url = API.article.getArticleTagsListsNoPagination;
            CommonUtils.GetRequest(data);
        },

        getArticleChannelLists(state, data) {
            data.url = API.article.getArticleChannelLists;
            CommonUtils.GetRequest(data);
        },

        deleteArticleTag(state, data) {
            data.url = API.article.deleteArticleTag;
            CommonUtils.GetRequest(data);
        },

        addTag(state, data) {
            data.url = API.article.addArticledTag;
            CommonUtils.PostRequest(data);
        },

        getArticleLists(state, data) {
            data.url = API.article.getArticleLists;
            CommonUtils.GetRequest(data);
        },

        stickArticle(state, data) {
            data.url = API.article.stickArticle;
            CommonUtils.PostRequest(data);
        },

        recommendArticle(state, data) {
            data.url = API.article.recommendArticle;
            CommonUtils.PostRequest(data);
        },

        deleteArticle(state, data) {
            data.url = API.article.deleteArticle;
            CommonUtils.GetRequest(data);
        },

        showArticle(state, data) {
            data.url = API.article.showArticle;
            CommonUtils.PostRequest(data);
        },

        getArticleInfo(state, data) {
            data.url = API.article.getArticleInfo;
            CommonUtils.GetRequest(data);
        },

        addArticle(state, data) {
            data.url = API.article.addArticle;
            CommonUtils.PostRequest(data);
        },

        editArticle(state, data) {
            data.url = API.article.editArticle;
            CommonUtils.PostRequest(data);
        },

        getDraftsList(state, data) {
            data.url = API.article.getDraftsList;
            CommonUtils.GetRequest(data);
        },

        getSceneOptions(state, data) {
            data.url = API.article.getSceneOptions;
            CommonUtils.GetRequest(data);
        },
        draftDelete(state, data) {
            data.url = API.article.draftDelete;
            CommonUtils.GetRequest(data);
        },
        manyDelete(state, data) {
            data.url = API.article.manyDelete;
            CommonUtils.GetRequest(data);
        },
        articleCopy(state, data) {
            data.url = API.article.articleCopy;
            CommonUtils.PostRequest(data);
        },
        generationLink(state, data) {
            data.url = API.article.generationLink;
            CommonUtils.GetRequest(data);
        },
        draftSave(state, data) {
            data.url = API.article.draftSave;
            data.needNotice = false
            CommonUtils.PostRequest(data);
        },
        draftAutoSave(state, data) {
            data.url = API.article.draftAutoSave;
            data.needNotice = false
            CommonUtils.PostRequest(data);
        },
    }

};

export default article;


// WEBPACK FOOTER //
// ./src/store/modules/article.js